import { BoxImage } from "@loot-os/ui/components/box-image";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@loot-os/ui/components/dialog";
import type { ReactNode } from "react";

import type { RankedOpen } from "../pages/shared/bestOpens.js";

/**
 * A pull that opens in a dialog: the item's full image as the focus, its name below. Full screen
 * on a phone. A placeholder for the pull details design, which adds the item's data as line items.
 */
export function ClassicPullDialog({ pull, children }: { pull: RankedOpen; children: ReactNode }) {
  const { item } = pull.open;
  return (
    <Dialog>
      {/* A card is not phrasing content, so the trigger is a div with a button's role. */}
      <DialogTrigger
        nativeButton={false}
        render={<div />}
        aria-label={pull.detailsLabel}
        className="block h-full cursor-pointer rounded-xl outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
      >
        {children}
      </DialogTrigger>
      <DialogContent className="top-0 left-0 h-dvh w-screen max-w-none translate-x-0 translate-y-0 content-center rounded-none ring-0 sm:max-w-none md:top-1/2 md:left-1/2 md:h-auto md:max-h-[calc(100dvh-4rem)] md:w-full md:max-w-lg md:-translate-x-1/2 md:-translate-y-1/2 md:rounded-xl md:ring-1">
        <BoxImage
          src={item.imageUrl}
          alt={item.name}
          className="aspect-5/7 max-h-[70dvh] w-full rounded-lg object-contain md:max-h-[60dvh]"
          fallback={<span className="text-6xl opacity-40">🃏</span>}
        />
        <DialogTitle className="text-xl leading-tight font-bold">{item.name}</DialogTitle>
      </DialogContent>
    </Dialog>
  );
}
